define.alias("ember-drag-sort/components/drag-sort-list", "media/components/drag-sort-list");